import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Result, Spin } from 'antd';

function StripeSuccess() {
    const navigate = useNavigate();

    useEffect(() => {
        // Wait for 3 seconds then redirect to home
        const timer = setTimeout(() => {
            navigate('/');
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column'
        }}>
            <Result
                status="success"
                title="Payment Successful!"
                subTitle="Please wait while we verify your payment and update your subscription..."
                extra={[
                    <Spin size="large" key="console" />
                ]}
            />
        </div>
    );
}

export default StripeSuccess;
